// extracted by mini-css-extract-plugin
module.exports = {"body":"body-ynKhjeC","footer":"footer-1xZ4snc"};